/**
 * Datas de mês em `DateKey` (America/Sao_Paulo, sem `Date`): a regra única de "mesma data n meses
 * antes/depois", usada pela comparação "mês passado" dos dados e pela navegação do calendário.
 */
import type { DateKey } from '@rota/contracts';
import { diffDaysKey, endOfMonthKey } from '@/lib/time';

/** A mesma data `n` meses antes/depois, presa ao último dia do mês (31/03 − 1 mês = 28/02). */
export function addMonthsKey(key: DateKey, n: number): DateKey {
  const y = Number(key.slice(0, 4));
  const m = Number(key.slice(5, 7)) - 1 + n;
  const year = y + Math.floor(m / 12);
  const month = (((m % 12) + 12) % 12) + 1;
  const first = `${year}-${String(month).padStart(2, '0')}-01`;
  const lastDay = Number(endOfMonthKey(first).slice(8, 10));
  const day = Math.min(Number(key.slice(8, 10)), lastDay);
  return `${first.slice(0, 8)}${String(day).padStart(2, '0')}`;
}

/** As datas do mesmo período no mês anterior (01/10–31/10 → 01/09–30/09). */
export function previousMonthKeys(range: { from: DateKey; to: DateKey }): { from: DateKey; to: DateKey } {
  return { from: addMonthsKey(range.from, -1), to: addMonthsKey(range.to, -1) };
}

/** Quantos dias tem o intervalo (inclusivo). */
export const daysInRangeKey = (range: { from: DateKey; to: DateKey }): number =>
  diffDaysKey(range.from, range.to) + 1;
